import React, { useState } from 'react';

import { Parallax } from 'rc-scroll-anim';

import { SimpleLightBox } from '@ui/moleculs/SimpleLightBox';

import { ReactComponent as Nature } from '@assets/images/icons/nature.svg';
import { ReactComponent as World } from '@assets/images/icons/world.svg';

import playBtn from '@assets/images/videos/play.png';

import mainImgLeft1 from '@assets/images/videos/video-7/bg/item-1.webp';
import mainImgLeft2 from '@assets/images/videos/video-7/bg/item-2.webp';
import mainImgLeft3 from '@assets/images/videos/video-7/bg/item-3.webp';

// import { stopAllYouTubeVideos } from '@features/helpers';

type BlockInfoTypes = {
  headerLeft?: string;
  headerRight?: string;
  index?: number;
  isDesktopOrLaptop?: any;
  active?: boolean;
  onClick: (prop: boolean) => void;
};

export const BlockVideo4: React.FC<BlockInfoTypes> = ({ children, ...props }) => {
  const [open, setOpen] = useState(false);
  const {
    // headerLeft,
    // headerRight,
    // index,
    isDesktopOrLaptop,
    active,
    onClick
  } = props;

  const toggleOpen = () => {
    setOpen(!open);
    const iframe = document.getElementById('iframe');
    iframe?.setAttribute('src', iframe.getAttribute('src') || '');
  };

  const showActive = (!isDesktopOrLaptop && active || isDesktopOrLaptop);
  const showNotActive = (!isDesktopOrLaptop && !active || isDesktopOrLaptop);

  return (
    <>
      <SimpleLightBox open={open} onClick={toggleOpen}>
        <div className={isDesktopOrLaptop ? "w-full h-full" : "portrait:absolute portrait:top-2/4 portrait:transform portrait:-translate-y-2/4 portrait:pt-55 landscape:h-full landscape:w-full mb-17 left-2.5 right-2.5"}>
          <iframe id="iframe" className={isDesktopOrLaptop ? "w-full h-full" : "portrait:absolute top-0 -left-0 w-full h-full" } width="560" height="315" src="https://iz.ru/video/embed/1179630" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
        </div>
      </SimpleLightBox>
      <div
        id="interview"
        className="
          max-w-1160
          mx-auto
          mb-10
          lg:mb-15
          flex
          flex-col
          lg:flex-row
          justify-between
          w-full
          text-white
          rounded-2.5xl
        "
      >
        {!isDesktopOrLaptop && <>
          <div
            className="
              flex
              justify-between
              mx-5
              mb-7.5
            "
          >
            <Parallax
              animation={{ scale: 1, opacity: 1, playScale: [0.1, 0.40] }}
              style={{ transform: 'scale(0.5)', opacity: 0 }}
              className={`
                bg-white
                relative
                inline-flex
                justify-center
                items-center
                border
                border-white
                rounded-full
                w-15
                h-15
                flex-shrink-0
                z-10
              `}
            >
              <Nature
                className={`
                  fill-current
                  text-smGrayText
                `}
                width={23}
                height={36}
              />
            </Parallax>
            <Parallax
              animation={{ scale: 1, opacity: 1, playScale: [0.1, 0.40] }}
              style={{ transform: 'scale(0.5)', opacity: 0 }}
              className={`
                bg-white
                relative
                inline-flex
                justify-center
                items-center
                border
                border-white
                rounded-full
                w-15
                h-15
                flex-shrink-0
                z-10
              `}
            >
              <World
                className={`
                  fill-current
                  text-smGrayText
                `}
                width={37}
                height={37}
              />
            </Parallax>
          </div>
          <h3 className="text-2.5xl font-extrabold text-white mx-5 mb-5">
            Полное видео
          </h3>
        </>}
        <div className="pl-5 lg:pl-15 pr-5 lg:pr-15 flex-1">
          <div
            className="relative"
          >
            <div
              id="video-4-lab-nat"
              onClick={toggleOpen}
              className="
                relative
                pt-63
                w-full
                lg:pt-0
                flex
                cursor-pointer
                z-10
                bg-gradient-to-r
                from-redText
                to-greenText
                rounded-2.5xl
                hover-zoom
                mb-5
                lg:mb-0
              "
            >

              <Parallax
                animation={{ x: 0, opacity: 1, playScale: [0.15, 0.50] }}
                style={{ transform: 'translateX(50px)', opacity: 0 }}
                className="absolute left-2/4 top-2/4 lg:top-0 -mt-20 lg:mt-12 -ml-28 lg:-ml-88"
              >
                <img
                  src={mainImgLeft2}
                  width={isDesktopOrLaptop ? "319" : "96" }
                  height={isDesktopOrLaptop ? "325" : "99" }
                  alt=""
                />
              </Parallax>

              <Parallax
                animation={{ x: 0, opacity: 1, playScale: [0.25, 0.50] }}
                style={{ transform: 'translateX(-50px)', opacity: 0 }}
                className="absolute left-2/4 top-2/4 lg:-top-4 -mt-20 lg:mt-0 lg:-ml-6"
              >
                <img
                  src={mainImgLeft3}
                  width={isDesktopOrLaptop ? "414" : "126" }
                  height={isDesktopOrLaptop ? "465" : "141" }
                  alt=""
                />
              </Parallax>

              <img
                className="absolute lg:relative left-2/4 top-2/4 lg:top-0 -mt-16 lg:mt-24 lg:mb-25 -ml-19 lg:-ml-50"
                src={mainImgLeft1}
                width={isDesktopOrLaptop ? "399" : "147" }
                height={isDesktopOrLaptop ? "399" : "147" }
                alt=""
              />

              {isDesktopOrLaptop && <div className="absolute bottom-10 left-15">
                <h3 className="text-4xl font-sans font-extrabold mb-2.5">
                  Полное видео
                </h3>
                <p className="text-md font-serif leading-6.5 m-0 max-w-smmd">
                  Круглый стол на тему «Лабораторное происхождение коронавируса: за и против»
                </p>
              </div>}

              <img
                className="absolute left-2/4 top-2/4 -ml-8 lg:-ml-13 -mt-8 lg:-mt-13 filter drop-shadow-4xl transition"
                src={playBtn}
                width={isDesktopOrLaptop ? "101" : "60" }
                height={isDesktopOrLaptop ? "101" : "60" }
                alt=""
              />

            </div>
            {!isDesktopOrLaptop && <p className="font-serif text-base leading-6.5">
              Подведение итогов на основе видео, тезисы. Короткий текст на несколько строчек. Возможно, процентное соотношение аргументов за и против
            </p>}
          </div>

        </div>
      </div>
    </>
  );
}